import { createStore } from "vuex";


import homePage from './homePage.js'
import profile from "./profile.js";

const store = createStore({
  modules: {
    homePage,
    profile,
  }
})

export default store